import { render, staticRenderFns } from "./ApplyAuthView.vue?vue&type=template&id=0f5ff8bc&scoped=true"
import script from "./ApplyAuthView.vue?vue&type=script&lang=js"
export * from "./ApplyAuthView.vue?vue&type=script&lang=js"
import style0 from "./ApplyAuthView.vue?vue&type=style&index=0&id=0f5ff8bc&prod&lang=scss&scoped=true"
import style1 from "./ApplyAuthView.vue?vue&type=style&index=1&id=0f5ff8bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ff8bc",
  null
  
)

export default component.exports